module.exports = __webpack_public_path__ + "img/Aquilegia_coerulea.aac61d66.jpg";